import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getConsent } from "api/consent";
import { changeActiveSection, changeMaxActiveSection } from "redux/userInfo";
import { setconsentText, setdeclarationConsent } from "redux/consentReducer";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "lib/LoadingSpinner";
import { Placeholder } from "react-bootstrap";
import { updateWorkflowInfo } from "api/formDisplay";
import { incrementActiveStepOrder } from "redux/conditionalRendering";
import "./index.scss";
import moment from "moment";
const Consent = (props) => {
  const {
    finalSubmission,
    consentName,
    layout,
    consent,
    handleDeclarationAcceptance,
    setSelectedData = () => {},
  } = props;
  const dispatch = useDispatch();
  const { subWfId } = useParams();
  const activeSection = useSelector((state) => state.userInfo?.activeSection);
  const stepperSections = useSelector(
    (state) => state?.stepperReducer?.sections
  );
  const receivedConsent = useSelector(
    (state) => state?.consentReducer?.consentConfig
  );
  const consents = useSelector((state) => state?.formData?.consents);
  const consentConfig = useSelector(
    (state) => state?.consentReducer?.consentConfig
  );
  const consentId = useSelector(
    (state) => state?.consentReducer?.consentConfig?._id
  );
  const consentText = useSelector(
    (state) => state?.consentReducer?.consentText
  );
  const consentType = useSelector(
    (state) => state?.consentReducer?.consentConfig?.service_name
  );

  const declarationConsent = useSelector(
    (state) => state?.consentReducer?.declarationConsent
  );
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  const consentLoading = useSelector((state) => state?.consentReducer?.loading);
  const [checked, setChecked] = useState(false);
  const [name, setName] = useState("");
  const [nextbutton, setNextButton] = useState(true);
  const navigate = useNavigate();

  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  //! DONOT REMOVE THIS
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const organisationId = useSelector((state) => state.formData?.selectedData?.organisation_id)

  const IndirectEval = (evalString) => {
    // const selectedData = useSelector((state)=>state.formData.selectedData)
    return eval(evalString);
  };

  const handleChange = (consentName) => {
    setName(consentName);
    setChecked((checked) => !checked);
  };

  useEffect(() => {
    dispatch(
      getConsent({ id: consent.consent_id, sub_id: decryptedId?.subWfId ,organisation_id:organisationId})
    );
    if (decryptedId.userId != workflowUser?.subworkflows?.user_id) {
      setNextButton(false);
    }
  }, [consent]);

  useEffect(() => {
    if (layout === "regular") setNextButton(false);
  }, [consentConfig]);

  useEffect(() => {
    let updatedObj = { ...consents };
    updatedObj[name] = checked;
    dispatch(
      setSelectedData({
        key: "consents",
        value: { ...consents, ...updatedObj },
      })
    );
  }, [checked]);


  useEffect(() => {
    const element = document.getElementById("consents_text");
    dispatch(setconsentText(element?.innerHTML));
  }, [receivedConsent?.consent_text]);
  if (consentLoading)
    return (
      <div className="consentDiv">
        <Placeholder animation="glow">
          <Placeholder xs={6} />
        </Placeholder>
        <Placeholder animation="glow">
          <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} />{" "}
          <Placeholder xs={6} /> <Placeholder xs={8} />
        </Placeholder>
      </div>
    );
  return (
    <div className="consentDiv">
      <div className="consentTitle fs-21px fw-bold mb-3">{consent.title}</div>
      <div className="consentText">
        <div>
          {receivedConsent?.is_checked && (
            <input
              type="checkbox"
              checked={checked}
              onChange={() => handleChange(consentName)}
            />
          )}
        </div>
        <div
          id="consents_text"
          key={2}
          dangerouslySetInnerHTML={{ __html: receivedConsent?.consent_text }}
        />
      </div>
      <div style={{ display: "flex" }}>
      </div>
    </div>
  );
};

export default Consent;
